import { Link } from 'react-router-dom'

function Logo({ light = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 shrink-0">
      <span className="flex items-center justify-center h-9 w-9 sm:h-10 sm:w-10 rounded-lg bg-coral text-white font-extrabold text-lg">
        +
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-extrabold text-lg sm:text-xl ${light ? 'text-white' : 'text-primary'}`}>
          Meditex
        </span>
        <span className={`text-[10px] sm:text-xs font-medium tracking-wide uppercase ${light ? 'text-primary-100' : 'text-accent-600'}`}>
          Healthcare Hub
        </span>
      </span>
    </Link>
  )
}

export default Logo
